import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage as a fallback
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gawx_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
